/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { useLabels } from '@/wpt-lib/pdf/useData';
import { label } from '@/wpt-lib/utils/label';

const ResearchBenchmarks = ({
    researchExpectationsAreas = {},
    researchExpectationsLevel = {},
}: Partial<{
    researchExpectationsAreas: { [area: string]: boolean };
    researchExpectationsLevel: { [area: string]: string };
}>) => {
    const areas = useLabels('researchExpectationsAreas');

    return (
        <>
            {Object.entries(researchExpectationsAreas)
                .filter(([, a]) => a)
                .map(([area]) => (
                    <Row key={area} widths={[80, 20]}>
                        <ValueCell single label="Aligned Benchmark" value={label(areas, area)} />
                        <ValueCell single label="Academic Level" value={researchExpectationsLevel[area]} />
                    </Row>
                ))}
        </>
    );
};

export default ResearchBenchmarks;
